// Import only when an export is requested. The module runtime reuses successful
// loads; a rejected promise is not retained here, so a later click can retry.
export async function loadPdfExportTools() {
  const [{ jsPDF }, { default: html2canvas }] = await Promise.all([
    import('jspdf'),
    import('html2canvas'),
  ]);
  return { jsPDF, html2canvas };
}

export async function loadEmailPdfTools() {
  const [{ PDFDocument }, { default: html2canvas }] = await Promise.all([
    import('pdf-lib'),
    import('html2canvas'),
  ]);
  return { PDFDocument, html2canvas };
}
